import { uniqueId } from 'lodash';
import { DurationType, PricingType } from '../../../stores/types/price.interface';

export interface TierPriceItem {
  id?: string;
  price: string;
  pricingType: PricingType;
  duration: string;
  durationUnit: DurationType;
}

export const tierPriceItem = (): TierPriceItem => ({
  id: uniqueId(),
  price: '',
  pricingType: PricingType.BILLED_BY_EFFECTIVE_CHARGING_TIME,
  duration: '',
  durationUnit: DurationType.HOUR,
});
